import React, { useState } from 'react';
/**
 * `RenewalsMobileInfoBar` renders a mobile-only accordion containing
 * `RenewalsPageInfo`.
 *
 * It is shown for key renewals pages (personal details, vehicle details, quote,
 * summary, direct debit, single payment) and hidden elsewhere.
 */

import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { PageAbsolutePath } from '../../../consts/Common';
import RenewalsPageInfo from './RenewalsPageInfo';
import { JourneyState } from '../../common/CommonTypes';

type PageInfoProps = {
  renewalsJourney: JourneyState;
  currentPath: string;
  setExpandedDocIds: (docIds: string[]) => void;
};

const RenewalsMobileInfoBar = ({
  renewalsJourney,
  currentPath,
  setExpandedDocIds
}: PageInfoProps): JSX.Element => {
  const [expanded, setExpanded] = useState<boolean>(true);

  const handleChange = () => setExpanded(!expanded);

  const getPanelHeading = () => {
    switch (currentPath) {
      case PageAbsolutePath.Renewals.PersonalDetails:
      case PageAbsolutePath.Renewals.VehicleDetails:
      case PageAbsolutePath.Renewals.Quote:
      case PageAbsolutePath.Renewals.Summary:
      case PageAbsolutePath.Renewals.DirectDebit:
      case PageAbsolutePath.Renewals.SinglePayment:
        return 'More information';
      default:
        return '';
    }
  };

  const getAccordionContent = () => {
    switch (currentPath) {
      case PageAbsolutePath.Renewals.PersonalDetails:
      case PageAbsolutePath.Renewals.VehicleDetails:
      case PageAbsolutePath.Renewals.Quote:
      case PageAbsolutePath.Renewals.Summary:
      case PageAbsolutePath.Renewals.DirectDebit:
      case PageAbsolutePath.Renewals.SinglePayment:
        return (
          <RenewalsPageInfo
            currentPath={currentPath}
            renewalsJourney={renewalsJourney}
            setExpandedDocIds={setExpandedDocIds}
          />
        );
      default:
        return '';
    }
  };

  const mobileInfo = () => {
    switch (currentPath) {
      case PageAbsolutePath.Renewals.PersonalDetails:
      case PageAbsolutePath.Renewals.VehicleDetails:
      case PageAbsolutePath.Renewals.Quote:
      case PageAbsolutePath.Renewals.Summary:
      case PageAbsolutePath.Renewals.DirectDebit:
      case PageAbsolutePath.Renewals.SinglePayment:
        return (
          <div className='desktop-hide mobile-info-bar'>
            <Accordion expanded={expanded} onChange={handleChange}>
              <AccordionSummary
                id='mobile-more-information'
                expandIcon={
                  <span className='float-right'>
                    <ExpandLessIcon />
                  </span>
                }>
                <span>{getPanelHeading()}</span>
              </AccordionSummary>
              <AccordionDetails>
                {
                  <div className='mobile-content-info page-info-container'>
                    {getAccordionContent()}
                  </div>
                }
              </AccordionDetails>
            </Accordion>
          </div>
        );
      default:
        return '';
    }
  };

  return <div>{mobileInfo()}</div>;
};

export default RenewalsMobileInfoBar;
